import { render } from "./SectionContact2.vue?vue&type=template&id=23c5193e&scoped=true"
import script from "./SectionContact2.vue?vue&type=script&lang=js"
export * from "./SectionContact2.vue?vue&type=script&lang=js"

import "./SectionContact2.vue?vue&type=style&index=0&id=23c5193e&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c5193e"]])

export default __exports__